import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/OrderSetupPage.css';
import {
    setPaymentMethod, setDeliveryMethod, getPaymentMethod, getDeliveryMethod
} from "../../utils/storage";
import SelectComponent from "./SelectComponent";


const OrderSetupPage = () => {
    console.log('OrderSetupPage');
    const navigate = useNavigate();
    const [error, setError] = useState('');
    //const storeObj = getStoreObj();
    const [paymentMethod, setupPayMethod] = useState(getPaymentMethod())
    const [deliveryMethod, setupDelivMethod] = useState(getDeliveryMethod())


    const handlePaymentMethod = (method) => {
        if (paymentMethod === method) {
            setPaymentMethod(null)
            setupPayMethod(null)
        }else{
            setPaymentMethod(method);
            setupPayMethod(method);
        }

    };

    const handleDeliveryMethod = (method) => {
        if (deliveryMethod === method) {
            setDeliveryMethod(null)
            setupDelivMethod(null)
        } else {
            setDeliveryMethod(method);
            setupDelivMethod(method);
        }
    }

    const handleContinue = () => {
        if (!paymentMethod || !deliveryMethod) {
            setError('Будь ласка, оберіть спосіб оплати та доставки.');
        } else {
            setError('');
            navigate('/order-submit');
        }
    };


    return (
        <div className="checkout-page">
            <h1>Оформлення замовлення</h1>
            <div className="selection">
                <h2>Виберіть спосіб доставки</h2>
                <div className="button-group delivery_buttons">
                    <SelectComponent
                        img="/images/pickup_icon.svg"
                        h4Option="Самовивіз"
                        pOption="Забирайте в магазині"
                        selectType={deliveryMethod}
                        selectValue="pickup"
                        onSelected={handleDeliveryMethod}
                        />
                    <SelectComponent
                        img="/images/delivery_icon.svg"
                        h4Option="Доставка"
                        pOption="Привезе кур’єр"
                        selectType={deliveryMethod}
                        selectValue="store-delivery"
                        onSelected={handleDeliveryMethod}
                        />
                </div>
            </div>

            <div className="selection">
                <h2>Виберіть спосіб оплати</h2>
                <div className="button-group">
                    <SelectComponent
                        img="/images/credit_card_icon.svg"
                        h4Option="Оплата онлайн"
                        pOption="Зручно і швидко"
                        selectType={paymentMethod}
                        selectValue="online"
                        onSelected={handlePaymentMethod}
                        />
                    <SelectComponent
                        img="/images/cash_icon.svg"
                        h4Option="Оплата при отриманні"
                        pOption="В магазині готівкою"
                        selectType={paymentMethod}
                        selectValue="cash"
                        onSelected={handlePaymentMethod}
                        />
                </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
                className="primary_button"
                onClick={handleContinue}
                id="order_setup__continue"
            >Продовжити
            </button>
        </div>
    );
};

export default OrderSetupPage;
